'use client'

import PropTypes from 'prop-types'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'
import MUIDivider from '@mui/material/Divider'
import { WizardSidebarTimeline } from '@repo/ui/WizardSidebarTimeline'

export const WizardSidebar = ({
  wideMode = false,
  title = 'Wizard title goes here',
  wizardConfig = [],
  handleStageButtonClick,
  handleStepButtonClick,
  currentStageId,
  currentStepId,
  wizardId
}) => {
  return (
    <MUIStack
      direction="column"
      data-testid="WizardSidebar"
      sx={{
        width: wideMode ? '300px' : '270px',
        height: '100%',
        padding: '16px',
        background: 'white',
        borderTopLeftRadius: '4px',
        borderBottomLeftRadius: '4px'
      }}
    >
      <MUITypography
        variant="h5"
        sx={{
          mb: 0,
          lineHeight: '134%',
          height: 'auto',
          userSelect: 'none'
        }}
      >
        {title}
      </MUITypography>

      <MUITypography variant="body1" sx={{ color: 'text.secondary', mb: '14px', userSelect: 'none' }}>
        Step-by-step
      </MUITypography>

      <MUIDivider
        sx={{
          width: wideMode ? '268px' : '238px',
          borderBottomWidth: '1px',
          borderColor: '#051C331F'
        }}
      />

      <WizardSidebarTimeline
        wizardConfig={wizardConfig}
        handleStepButtonClick={handleStepButtonClick}
        handleStageButtonClick={handleStageButtonClick}
        currentStageId={currentStageId}
        currentStepId={currentStepId}
        wizardId={wizardId}
      />
    </MUIStack>
  )
}

WizardSidebar.propTypes = {
  wideMode: PropTypes.bool,
  title: PropTypes.string,
  wizardConfig: PropTypes.array,
  handleStageButtonClick: PropTypes.func,
  handleStepButtonClick: PropTypes.func,
  currentStageId: PropTypes.string,
  currentStepId: PropTypes.string,
  wizardId: PropTypes.string
}
